<template>
  <div class="font-edit">
    <div class="font-family">
      <div class="setting-container">
        <draggable tag="div" class="list-group" handle=".drag-btn" filter=".is-disabled" :list="value.fontFamilyList">
          <div v-for="(fontFamily, index) in value.fontFamilyList" class="setting-item" :key="fontFamily.key">
            <div class="drag-btn" :class="isDisabled && 'is-disabled'">
              <i class="iconfont iconMore"></i>
            </div>
            <el-input v-model="fontFamily.name" class="value" :class="!fontFamily.name && !fontFamily.isDefault && isNameError[fontFamily.key] && 'is-error'" :disabled="fontFamily.isDefault || isDisabled" :placeholder="$t(`${i18nPrefix}.label.name`)" @focus="handleFocus(fontFamily.key)"></el-input>
            <div v-if="fontFamily.fileList.length || fontFamily.isDefault" class="upload-success">
              <i class="uploaded-icon iconfont icondone"></i>
            </div>
            <el-upload
              v-if="!fontFamily.isDefault"
              class="upload-font"
              action=""
              accept=".ttf,.otf,.woff,.woff2,.eot"
              :limit="1"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="(file) => handleFontChange(file, fontFamily)"
              :file-list="fontFamily.fileList"
              :class="(!fontFamily.fileList || fontFamily.fileList.length === 0) && !fontFamily.isDefault && isFileError[fontFamily.key] && 'is-error'"
            >
              <el-button v-if="!fontFamily.fileList || fontFamily.fileList.length === 0" size="small" type="primary" :disabled="isDisabled">
                {{$t( `${i18nPrefix}.btn.uploadFont`) }}
              </el-button>
              <el-button v-else size="small" :disabled="isDisabled">
                {{ $t(`${i18nPrefix}.btn.reuploadFont`) }}
              </el-button>
            </el-upload>
            <el-switch v-model="fontFamily.active" class="active-switch" :disabled="isDisabled" @change="handleFontFamilyActiveChange(fontFamily, $event)"></el-switch>
            <div v-if="!fontFamily.isDefault" class="btn-group">
              <i v-if="showDeletedFontFamilyBtn" class="delete-btn iconfont iconRemove" :class="isDisabled && 'is-disabled'" @click="handleDeleteFontFamily(index)"></i>
              <i class="add-btn iconfont iconAdd1" :class="isDisabled && 'is-disabled'" @click="handleAddFontFamily(index)"></i>
            </div>
          </div>
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { getFilePath, uploadFile } from '@/utils/qiniu'
import draggable from 'vuedraggable'
import { mapGetters } from 'vuex'

export default {
  components: {
    draggable
  },
  props: {
    value: {
      required: true
    },
    fontList: {
      type: Array,
      default () {
        return []
      }
    },
    fontSizeList: {
      type: Array,
      default () {
        return [14, 18, 20, 22, 24, 28, 30, 36, 42, 50, 60, 80, 90]
      }
    },
    isDisabled: {
      type: Boolean,
      default: true
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data () {
    return {
      i18nPrefix: 'admin.company.customCompanyTheme',
      fileList: [],
      fontWeightList: [
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900,
        'bold',
        'bolder',
        'lighter'
      ],
      fontTypeMap: {
        ttf: 'truetype',
        otf: 'opentype',
        woff: 'woff',
        woff2: 'woff2',
        svg: 'svg',
        eot: 'eot'
      },
      isNameError: {},
      isFileError: {}
    }
  },
  computed: {
    showDeletedFontFamilyBtn () {
      return _.filter(this.value.fontFamilyList, item => !item.isDefault)?.length > 1
    }
  },
  created () {

  },
  mounted () {

  },
  methods: {
    ...mapGetters('account', ['getCurrentAccount']),
    handleFontSelect (command, type) {
      this.$emit('change', {
        ...this.value,
        [type]: command
      })
    },
    handleChangeFontBold () {
      this.$emit('change', {
        ...this.value,
        fontBold: !this.value.fontBold
      })
    },
    generateFileKey (contentType, contentItemId) {
      const account = this.getCurrentAccount()
      const fileKey = `job/custom_content/${contentType}/${contentItemId}/${account.id}/${new Date().valueOf()}`
      return fileKey
    },
    uploadFont () {
      const allPromiseList = []
      _.forEach(this.value.fontFamilyList, (fontFamily, fontIndex) => {
        _.forEach(fontFamily.fileList, (file, fileIndex) => {
          if (file.file) {
            allPromiseList.push(this.uploadFile(file.file.raw, fontIndex, fileIndex))
          }
        })
      })
      return allPromiseList
    },
    async uploadFile (file, fontIndex, fileIndex) {
      const fileKey = this.generateFileKey(fontIndex, fileIndex)
      await uploadFile(file, fileKey)
      getFilePath(fileKey)
      this.value.fontFamilyList[fontIndex].fileList.splice(fileIndex, 1, {
        url: getFilePath(fileKey),
        ext: this.fontTypeMap[file.name.split('.').pop()]
      })
    },
    handleFontChange (file, fontFamily) {
      fontFamily.fileList = [{
        file: file,
        url: file.url
      }]
      fontFamily.name = file.name.split('.')[0]
      fontFamily.active = true
    },
    handleDeleteFontFamily (index) {
      if (this.isDisabled) {
        return
      }
      this.value.fontFamilyList.splice(index, 1)
    },
    handleAddFontFamily (index) {
      if (this.isDisabled) {
        return
      }
      this.value.fontFamilyList.splice(index + 1, 0, {
        key: new Date().getTime(),
        name: '',
        fileList: [],
        active: false
      })
    },
    handleFontFamilyActiveChange (item, status) {
      if (!status) {
        return
      }
      if ((item.fileList.length === 0 || !item.name) && !item.isDefault) {
        if (item.fileList.length === 0) {
          this.isFileError[item.key] = true
        }
        if (!item.name) {
          this.isNameError[item.key] = true
        }
        this.$message.error(this.$t(`${this.i18nPrefix}.message.fieldIsRequired`))
        item.active = false
      }
    },
    handleFocus (key) {
      this.isNameError[key] = false
    }
  }
}
</script>

<style scoped lang="scss">
.font-edit {
  display: flex;
  align-items: left;
  flex-direction: column;

  .font-family {
    display: flex;
    margin-bottom: 10px;

    .label{
      line-height: 46px;
    }

    .setting-container {
      padding: 6px;

      .setting-item {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        &:last-child {
          margin-bottom: 0;
        }

        .drag-btn {
          margin-right: 10px;
          cursor: pointer;

          &.is-disabled {
            cursor: not-allowed;
          }
        }

        .name {
          margin-right: 10px;
          width: 34px;
          flex-shrink: 0;
        }

        .value {
          margin-right: 10px;

          &.is-error {
            ::v-deep {
              .el-input__inner {
                border-color: #f56c6c;
              }
            }
          }
        }

        .upload-font {
          margin-right: 10px;

          &.is-error {
            ::v-deep {
              .el-button {
                border-color: #f56c6c;
              }
            }
          }
        }

        .upload-success {
          display: flex;
          align-items: center;
          margin-right: 10px;

          .uploaded-icon {
            font-size: 12px;
            color: #0096cc;
            margin-right: 10px;
          }
        }

        .active-switch {
          margin-right: 10px;
        }

        .btn-group {
          display: flex;

          .delete-btn {
            font-size: 14px;
            color: red;
            margin-right: 6px;
            cursor: pointer;

            &.is-disabled {
              cursor: not-allowed;
              color: rgba($color: red, $alpha: 0.7)
            }
          }

          .add-btn {
            font-size: 14px;
            color: #0096cc;
            cursor: pointer;

            &.is-disabled {
              cursor: not-allowed;
              color: rgba($color: #0096cc, $alpha: 0.7)
            }
          }
        }
      }
    }
  }

  .font-size {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .label {
      flex-shrink: 0;
      margin-right: 10px;
    }
  }

  .font-color {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .label {
      flex-shrink: 0;
      margin-right: 10px;
    }
  }

  .font-weight {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .label {
      flex-shrink: 0;
      margin-right: 10px;
    }
  }
}

.font-size-option {
  .option-item {
    height: auto;
  }
}

.page-en {
  .font-edit {
    .font-family {
      .setting-container {
        .setting-item {
          .name {
            width: 42px;
          }
        }

      }
    }
  }
}
</style>
